<p-panel *ngIf="thermo!==null" styleClass="pt-3">
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full py-1 -mb-3">
			<div [class]="!onExtendedMobile() ? 'col-10' : 'col-12 flex justify-content-center'" class="py-2">
				<!-- class="py-0" --><span class="font-semibold white-space-nowrap">{{ 'THERMO_CONTROL' | translate
					}}</span>
			</div>
			<div [class]="!onExtendedMobile() ? 'col-2 flex justify-content-end' : 'col-12 flex justify-content-center'"
				class="py-0 pr-0">
				<!--<button pButton pRipple icon="pi cm-download" label="{{ 'EXPORT_METRICS_LIST' | translate }}"
					(click)="exportLog()" class="p-button-primary text-normal border-transparent font-medium py-1">
				</button>-->

			</div>
		</div>
	</ng-template>
	<div *ngIf="thermo.on_line === undefined || thermo.on_line === 0" class="grid">
		<div class="col-12 mt-3 py-2 bg-red-200 text-color flex align-items-center justify-content-center border-round-xl">
			{{ 'OFFLINE_NOT_REACHABLE_THERMO' | translate }}
		</div>
	</div>
	<form [formGroup]="thermoForm" *ngIf="thermo.on_line===1" class="w-full">
		<div class="grid">
			<!-- TEMP & THEMO CONTROLS SEASONS -->
			<div [class]="underTablet() ? (onExtendedMobile() ? '' : 'col-2') : ''"></div>
			<div [class]="underTablet() ? (onExtendedMobile() ? 'col-12' : 'col-8') : 'col-4 pr-1'">
				<div class="flex justify-content-between flex-wrap card border-round-3xl">
					<div class="flex flex-row w-full align-items-center justify-content-between">
						<div *ngIf="thermo.relay_status===0" class="humidityStyle">
						</div>
						<div *ngIf="thermo.relay_status===1 && thermo.current_season==='winter'"
							class="humidityStyle flex align-items-center">
							<i class="pi cm-snow text-2xl text-primary pr-2"></i>
							{{ 'RELAY_ON' | translate }}
						</div>
						<div *ngIf="thermo.relay_status===1 && thermo.current_season==='summer'"
							class="humidityStyle flex align-items-center">
							<i class="pi cm-sun text-2xl text-red-600 pr-2"></i>
							{{ 'RELAY_ON' | translate }}
						</div>
						<div class="humidityStyle flex align-items-center">
							<i class="pi pi-cloud text-2xl text-primary pr-2"></i>
							{{ thermo.hum_loc === undefine ? '- %' : thermo.hum_loc + ' %' }}
						</div>
					</div>
					<div class="flex flex-column py-4 w-full">
						<div class="temp-att-val flex justify-content-center text-7xl">
							{{ thermo.temp_loc + ' °C' }}
						</div>
						<div class="temp-att-txt flex justify-content-center">
							{{ 'CURRENT_TEMPERATURE' | translate }}
						</div>
					</div>
				</div>
			</div>
			<div [class]="underTablet() ? (onExtendedMobile() ? '' : 'col-2') : ''"></div>

			<div [class]="underTablet() ? 'col-12' : 'col-8 pl-1'">
				<div class="flex flex-wrap card border-round-3xl">
					<div class="flex flex-row align-items-center justify-content-center w-full">
						<div class="thermal-control-title text-lg">
							{{ 'THERMAL_CONTROL' | translate }}
						</div>
					</div>
					<div class="flex flex-row align-items-center justify-content-center w-full mt-2">
						<p-selectButton [options]="termalControlOptions" formControlName="thermalControl" optionValue="value"
							(onChange)="thermalControlChanged()" optionDisabled="disabled" class="w-full"
							tooltipPosition="bottom"
							pTooltip="{{ thermo.current_season==='off' || thermo.current_season==='antifreeze' ? ('CONTROLL_SEASON_LOCK' | translate) : ('NOT_ALL_FUNCTION_AVAILABLE_ON_WEB_APP' | translate) }}"
							[disabled]="thermo.current_season==='off' || thermo.current_season==='antifreeze'">
							<ng-template let-item pTemplate>
								<div class="flex align-items-center justify-content-center w-full">
									<div [class]="onExtendedMobile() ? '' : 'pr-2'"><i [class]="item.icon"></i></div>
									<span *ngIf="!onExtendedMobile()">{{item.name}}</span>
									<!-- <span *ngIf="onExtendedMobile()">{{item.name | truncate:[3]}}</span> -->
								</div>
							</ng-template>
						</p-selectButton>
					</div>
					<div class="flex flex-row align-items-center justify-content-center w-full mt-4">
						<div class="season-control-title text-lg">
							{{ 'SEASON_CONTROL' | translate }}
						</div>
					</div>
					<div class="flex flex-row align-items-center justify-content-center w-full mt-2 pb-2">
						<p-selectButton [options]="seasonControlOptions" formControlName="seasonControl"
							(onChange)="seasonControlChanged()" optionValue="value" class="w-full">
							<ng-template let-item pTemplate>
								<div class="flex align-items-center justify-content-center w-full">
									<div [class]="onExtendedMobile() ? 'pr-2' : 'pr-2'"><i [class]="item.icon"></i></div>
									<span *ngIf="!onExtendedMobile()">{{item.name}}</span>
									<span *ngIf="onExtendedMobile()">{{item.name | truncate:[3]}}</span>
								</div>
							</ng-template>
						</p-selectButton>
					</div>
				</div>
			</div>
			<!-- MANUAL THERMO SET -->
			<div [class]="onExtendedMobile() ? '' : 'col-2'" *ngIf="isVisibleManualControlTemperature();"></div>
			<div [class]="onExtendedMobile() ? 'col-12' : 'col-8'" *ngIf="isVisibleManualControlTemperature();">
				<div class="flex align-items-center justify-content-center flex-wrap card border-round-2xl">
					<div class="flex flex-row justify-content-center w-full pt-2 pb-3">
						<div id="set-temperature" class="text-lg">{{'SET_TEMPERATURE' | translate }}</div>
					</div>
					<div class="flex flex-column">
						<p-knob formControlName="temperature" size="250" [min]="5" [max]="35" [step]="0.1"
							class="cursor-pointer" valueTemplate="{{spinner}}°C" textColor="var(--text-color, Black)"
							valueColor="#00B0ED" rangeColor="#CED1D4" (onChange)="sliderStop($event)">
						</p-knob>
						<div class="flex flex-row justify-content-between px-6">
							<p-button icon="pi cm-minus" severity="primary" [rounded]="false" [text]="false"
								(click)="setSliderDecreaseValue()" [disabled]="isSliderMin()" />
							<p-button icon="pi cm-plus" severity="primary" [rounded]="false" [text]="false"
								(click)="setSliderIncreaseValue()" [disabled]="isSliderMax()" />
						</div>
					</div>
				</div>
			</div>
			<div [class]="onExtendedMobile() ? '' : 'col-2'" *ngIf="isVisibleManualControlTemperature();"></div>
		</div>
	</form>
</p-panel>